import Vue from "vue";
import moment from "moment";

export default {
  name: "roll-transfer-list",
  data: function () {
    return {
      keyword: "",
      keyword_status: null,
      keyword_side: null, // 'out' = เราส่งออก, 'in' = ส่งเข้าหาเรา
      busy: false,
      items: [],
      totalItem: 0,
      perPage: 20,
      currentPage: 1,
      apiStatus: "ไม่พบข้อมูล",
      role: "",
      branch: "",
      acting: false,
      fields: [
        { key: "document_no", label: "เลขที่เอกสาร", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2" },
        { key: "route", label: "ต้นทาง → ปลายทาง", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2" },
        { key: "items_count", label: "จำนวนม้วน", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2 text-right", class: "text-right" },
        { key: "creator.name", label: "ผู้สร้าง", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2" },
        { key: "status", label: "สถานะ", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2" },
        { key: "action", label: "#", thClass: "font-weight-bold text-xs-1/2", tdClass: "td-top text-xs-1/2", class: "text-right" },
      ],
    };
  },
  computed: {
    // ระดับผู้จัดการที่ทำใบโอนได้ (ตรงกับ backend RollTransferController)
    isManager() {
      return ["Branch Admin", "Branch Admin assistant", "Customer assistant manager"].includes(this.role);
    },
  },
  async mounted() {
    await this.getRole();
    this.onInitData(1);
  },
  methods: {
    async getRole() {
      const res = await this.$store.dispatch("Auth/getRole", {}, { root: true });
      this.role = res.data.role;
      this.branch = res.data.branch_id;
    },
    // ยกเลิกได้เฉพาะสาขาต้นทาง (หรือ Admin) และใบต้องยังรอรับ — เกณฑ์เดียวกับ backend
    canCancel(item) {
      if (!item || Number(item.status) !== 1) return false;
      if (this.role === "Admin") return true;
      return this.isManager && Number(this.branch) === Number(item.from_branch_id);
    },
    async onCancel(item) {
      const confirm = await this.$swal({
        icon: "warning",
        title: `ยกเลิกใบโอน ${item.document_no}?`,
        text: "ม้วนทั้งหมดจะกลับเข้าสต็อกสาขาต้นทางตามเดิม",
        showCancelButton: true,
        confirmButtonText: "ยกเลิกใบโอน",
        cancelButtonText: "ปิด",
      });
      if (!confirm.value) return;
      this.acting = true;
      try {
        await Vue.prototype.$axios.post(
          `${Vue.prototype.$host}/api/v1/roll-transfers/${item.uuid}/cancel`
        );
        this.$swal({ icon: "success", title: "ยกเลิกใบโอนเรียบร้อย", confirmButtonText: "ตกลง" });
        await this.onInitData(this.currentPage);
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message || "ยกเลิกไม่สำเร็จ");
      } finally {
        this.acting = false;
      }
    },
    formatDate(d) {
      return d ? moment(d).format("DD/MM/YYYY HH:mm") : "-";
    },
    statusText(s) {
      return { 1: "รอปลายทางรับ", 2: "รับแล้ว", 6: "ยกเลิก" }[s] || s;
    },
    statusVariant(s) {
      return { 1: "warning", 2: "success", 6: "secondary" }[s] || "light";
    },
    async onInitData(page) {
      try {
        this.busy = true;
        this.apiStatus = "กำลังค้นหาข้อมูล..";
        const qs = new URLSearchParams();
        qs.set("page", page || 1);
        qs.set("keyword", this.keyword || "");
        qs.set("keyword_status", this.keyword_status ?? "");
        qs.set("keyword_side", this.keyword_side ?? "");
        const result = await Vue.prototype.$axios.get(
          `${Vue.prototype.$host}/api/v1/roll-transfers?${qs.toString()}`
        );
        this.items = result.data.data || [];
        this.totalItem = result.data.total || 0;
        this.currentPage = page || 1;
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
      } catch (error) {
        this.busy = false;
        this.apiStatus = "ไม่พบข้อมูล";
        this.onExceptionHandler(error?.response?.data?.message);
      }
    },
    async generatePDF(uuid) {
      try {
        const result = await this.$axios.get(
          `${Vue.prototype.$host}/api/v1/roll-transfers/${uuid}/pdf`,
          { responseType: "blob" }
        );
        const blob = new Blob([result.data], { type: "application/pdf" });
        window.open(URL.createObjectURL(blob), "targetWindow", "width=900,height=700");
      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message);
      }
    },
  },
};
